<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <!-- <router-link class="float-btn" :to="{ name: 'ResellerRegisteredProductAdd'}">
      <i class="fa fa-plus my-float"></i>
    </router-link> -->

        <loading v-if="mountLoading" />

        <div class="superadmin-dashboard-area" v-else>
            <div class="row">
                <div class="col-sm-12 col-md-12" v-if="mountLoadingProductCount == 0">
                    <p class="text-center mt-5">
                        {{
                            $route.query.customer_id
                                ? 'Sorry selected customer doesnot have any product registered.'
                                : 'You currently have no registered Products.'
                        }}
                    </p>
                    <p class="text-center mt-3">
                        <router-link class="btn btn-primary px-4" :to="{name: 'ResellerRegisteredProductAdd'}">
                            <i class="fa fa-plus"></i> Add New Product
                        </router-link>
                    </p>
                </div>

                <div class="col-sm-12 col-md-12" v-else>
                    <p class="text-left mt-2">
                        <router-link class="btn btn-primary" :to="{name: 'ResellerRegisteredProductAdd'}">
                            <i class="fa fa-plus"></i> Add New Product
                        </router-link>
                    </p>
                </div>

                <div class="col-sm-12 col-md-12 mb-2" v-if="mountLoadingProductCount > 0">
                    <div class="row justify-content-between">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <input
                                class="search-input top-search-input"
                                :disabled="loading == true"
                                v-model="s"
                                placeholder="Search by Model / Serial Number"
                            />
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-12" v-if="registered_products.length == 0 && mountLoadingProductCount > 0">
                    <p class="text-center mt-5">No product found.</p>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3" v-bind:key="'product_' + index" v-for="(product, index) in registered_products">
                    <productItem :type="'reseller'" :editcallback="editCallBack" :deletecallback="deleteCallBack" :product="product" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import {mapGetters, mapActions} from 'vuex';

export default {
    name: 'registerProductCustomer',
    data() {
        return {
            loading: false,
            s: '',
            mountLoading: true,
            mountLoadingProductCount: 0,
            loaded: true,
            currentPage: 1,
            pageNavs: [],
            registered_products: []
        };
    },

    computed: {
        ...mapGetters({
            vg_loggedIn_user_id: 'auth/userid'
        })
    },
    watch: {
        s(val) {
            this.currentPage = 1;
            this.fetchRegProductsFiltered();
        },
        '$route.query.customer_id'(val) {
            if (!val) {
                this.currentPage = 1;
                this.mountLoading = true;
                this.fetchRegProductsFiltered(1);
            }
        }
    },

    mounted() {
        this.fetchRegProductsFiltered();
    },

    methods: {
        fetchRegProductsFiltered: _.debounce(function () {
            this.loading = true;
            let urlquery = '&s=' + this.s;
            if (this.$route.query.customer_id) {
                urlquery += '&customer_id=' + this.$route.query.customer_id;
            }
            const url = `${Env.baseUrl}/reseller/reg-product/all?page=${this.currentPage + urlquery}`;
            AuthApis.getApi(url)
                .then(async (res) => {
                    if (this.mountLoading) {
                        this.mountLoadingProductCount = res.data.payload.length;
                    }
                    this.mountLoading = false;
                    this.registered_products = res.data.payload;
                    this.pageNavs = res.data.nav;
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
        }, 500),

        // /**
        //  * Fetch reg products
        //  */
        // async fetchRegProducts() {
        //   this.loaded = false;
        //   const url = `${Env.baseUrl}/reseller/reg-product/all?page=${this.currentPage}`;
        //   AuthApis.getApi(url).then(async (res) => {
        //     await this.va_setRegProducts(res.data.payload)
        //     this.pageNavs= res.data.nav;
        //     this.loaded = true;
        //   }).catch(err => {
        //     console.log(err)
        //     this.loaded = true;
        //   })
        // },

        /**
         * Fetch page data
         */
        fetchPage(pageNo) {
            this.currentPage = pageNo;
            this.fetchRegProductsFiltered();
        },

        /**
         * Delete product
         */
        deleteThis(product) {
            this.$confirm({
                title: `DELETE?`,
                message: 'Are you sure you want to delete ' + product.sku_with_serial_number,
                button: {
                    no: 'No',
                    yes: 'Yes'
                },
                callback: (confirm) => {
                    if (confirm) {
                        const url = `${Env.baseUrl}/reseller/reg-product/delete/${product.id}`;
                        AuthApis.deleteApi(url)
                            .then(async (res) => {
                                this.fetchRegProductsFiltered(this.currentPage);
                                this.$toasted.global.success({
                                    message: 'Successfully deleted.'
                                });
                            })
                            .catch((err) => {
                                this.$toasted.global.error({
                                    message: err.response ? err.response.data.message : 'Failed, please try again later.'
                                });
                            });
                    }
                }
            });
        },

        viewCocCertificate(obj) {
            this.va_pdfModal(true);
            this.va_pdfModalObj(obj);
        },

        /**
         * editCallBack
         */
        editCallBack(product) {
            this.$router.push({
                name: 'ResellerRegisteredProductEdit',
                params: {
                    id: product.id
                }
            });
        },

        /**
         * editCallBack
         */
        deleteCallBack(product) {
            this.deleteThis(product);
        },

        ...mapActions({
            va_setRegProducts: 'reseller_reg_products/setList',
            va_pdfModal: 'pdf/setActive',
            va_pdfModalObj: 'pdf/setActiveObj'
        })
    }
};
</script>
